import { Spinner } from "spin.js";

$.widget("custom.autogirosubscription", {
    options: {
        step: "0", ssn: "", bankidvisibledata: "", accountnumberwithclearing: "", clearingNumber: "", accountNumber: "", errormessage: ""
    },
    _create: function () {
        var $widget = this;

        var getUrlParameter = function getUrlParameter(sParam) {
            var sPageURL = window.location.search.substring(1),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;

            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                }
            }
        };

        function removeParam(key, sourceUrl) {
            var rtn = sourceUrl.split("?")[0],
                param,
                paramsArr = [],
                queryString = (sourceUrl.indexOf("?") !== -1) ? sourceUrl.split("?")[1] : "";
            if (queryString !== "") {
                paramsArr = queryString.split("&");
                for (var i = paramsArr.length - 1; i >= 0; i -= 1) {
                    param = paramsArr[i].split("=")[0];
                    if (param === key) {
                        paramsArr.splice(i, 1);
                    }
                }
                rtn = rtn + "?" + paramsArr.join("&");
            }
            return rtn;
        }

        //First step
        switch (this.options.step) {
            case 0:
                var campaignCode = $("#CampaignCode");
                var enterCampaignCodeButton = $("#EnterCampaignCodeButton");
                
                enterCampaignCodeButton.click(function () {
                    if (campaignCode.val().length > 3) {
                        var href = window.location.href;
                        href = removeParam("kampanj", href);
                        if (window.location.href.indexOf("?") == -1) {
                            href = href + "?kampanj=" + campaignCode.val();
                        } else {
                            href = href + "&kampanj=" + campaignCode.val();
                        }
                        window.location.href = href;
                    }
                });

                break;
            case 1:
                break;
            case 2:
                paymentStep();
                break;

            case 3:
                confirmationStep(this.options);
                break;
        }

        function confirmationStep(options) {
            const clearingText = $('#ClearingText');
            const accountText = $('#AccountText');
            const policyCheckBox = $('#PolicyCheckBox');
            const confirmationButton = $("#ConfirmationButton");

            var accountNumberWithClearing = options.accountnumberwithclearing;
            var clearingNumber = options.clearingnumber;
            var accountNumber = options.accountnumber;

            if (clearingNumber != "") {
                clearingText.html(clearingNumber);
                accountText.html(accountNumber);
            } else {
                if (accountNumberWithClearing != "") {
                    var clearing = accountNumberWithClearing.slice(0, accountNumberWithClearing.indexOf(','));
                    var account = accountNumberWithClearing.slice(accountNumberWithClearing.indexOf(',') + 1, accountNumberWithClearing.length);

                    clearingText.html(clearing);
                    accountText.html(account);
                }
            }

            policyCheckBox.change(function () {
                if (this.checked) {
                    confirmationButton.prop("disabled", false);
                } else {
                    confirmationButton.prop("disabled", true);
                }
            });
           
        }

        function paymentStep() {
            var spinner;
            var pollInterval;

            const autoGiro = "autogiro";
            const account = "account";
            const invoice = "invoice";

            var uservalues = {};
            var hasOpenedBankid = false;

            var socialSecurityButton = $('#SocialSecurityButton');
            var socialSecurityButtonSpinner = $('#SocialSecurityButtonSpinner');
            var socialSecurityChangeButton = $('#SocialSecurityChangeButton');
            var campaignCode = $("#CampaignCode");
            var input = $("#SocialSecurityInput");
            var message = $("#MessageForCustomer").text("").addClass("hidden");
            var label = $("#SocialSecurityLabel");
            var inputBlock = $("#SocialSecurityInputBlock");
            var labelBlock = $("#SocialSecurityLabelBlock");

            var selectBankBlock = $("#SelectBankBlock");
            var selectBankLabelBlock = $("#SelectBankLabelBlock");
            var selectBankButton = $("#SelectBankButton");
            var selectBankChangeButton = $("#SelectBankChangeButton");
            var selectBankInput = $("#SelectBankInput");
            var selectBankLabel = $("#SelectBankLabel");

            var bankIdOverlay = $("#BankIdOverlay");
            var bankIdDefaultMessage = $("#BankIdDefaultMessage");
            var bankIdErrorMessage = $("#BankIdErrorMessage");
            const bankIdWaitingForResponseFromAppMessage = $("#BankIdWaitingForResponseFromApp");
            var qrImage = $("#QrImage");
            var abortBankIDButtonBillecta = $("#AbortBankIDButtonBillecta");
            //selectBankAccountInput = $("#m.Form.SubscriptionPackageFormDataPaymentStep.BankAccount");
            var selectBankAccountInput = $("#BankAccountDropDown")[0];
            var selectBankAccountBlock = $("#SelectBankAccountBlock");

            var paymentTypeHiddenInput = $("#PaymentType");
            var titleH1 = $("#TitleH1");
            var autogiroTabBlock = $("#AutogiroTabBlock");

            var billectaBlock = $("#BillectaBlock");
            var manualBlock = $("#ManualBlock");
            var billectaBlockTab = $("#BillectaBlockTab");
            var manualBlockTab = $("#ManualBlockTab");

            var radioInvoiceOrAutogiro = $("#RadioInvoiceOrAutogiro");
            var invoiceBlock = $("#InvoiceBlock");
            var paymentStepBlock = $("#PaymentStepBlock");

            var submitFormButton = $("#SubmitFormButton");
            submitFormButton.prop("disabled", true);

            var existingSubscriptionBlock = $("#ExistingSubscriptionBlock");
            var paymentOptionsButton = $("#PaymentOptionsButton");

            $("#ClearingInput").val("");
            $("#BankAccountInput").val("");
            $("#BankAccountDropDown").val("");

            spinner = new Spinner($.extend({}, DefaultOptions.Spinner, { color: "#000" }));

            $(socialSecurityButton).click(function () {
                socialSecurityButtonClick();
            });

            socialSecurityChangeButton.click(function () {
                setStageOne();
            });

            abortBankIDButtonBillecta.click(function () {
                if (pollInterval) {
                    clearInterval(pollInterval);
                }
                bankIdErrorMessage.hide();
                spinner.stop();
                bankIdOverlay.hide();
                qrImage.hide();
                setStageOne();
            });

            selectBankButton.click(function () {
                selectBankButtonClick();
            });

            selectBankChangeButton.click(function () {
                setStageTwo();
            });

            manualBlockTab.click(function () {
                showManual();
            });

            billectaBlockTab.click(function () {
                showBillecta();
            });

            paymentOptionsButton.click(function () {
                selectPaymentType();
            });

            input.keypress(function (e) {
                if (e.key == '-') {
                    return false;
                }
                if (e.key === 'Enter') {
                    socialSecurityButtonClick();
                }
            });
            $("input[name='invoiceOrAutogiro']").change(function () {
                showInvoiceOrAutogiro($("input[name='invoiceOrAutogiro']:checked").val())
            });

            function showInvoiceOrAutogiro(radioValue) {

                //if pren -> submit, else stageTwo, change payment type to AG
                if (radioValue == "autogiro") {
                    paymentStepBlock.slideDown();
                    invoiceBlock.slideUp();
                    paymentTypeHiddenInput.val(autoGiro);
                    if (selectBankAccountBlock.css('display') == "block") {
                        submitFormButton.prop("disabled", false);
                    } else {
                        submitFormButton.prop("disabled", true);
                    }
                } else {
                    paymentStepBlock.slideUp();
                    invoiceBlock.slideDown();
                    paymentTypeHiddenInput.val(invoice);
                    submitFormButton.prop("disabled", false);
                }
                $('html, body').animate({
                    scrollTop: radioInvoiceOrAutogiro.offset().top
                }, 2000);
            }

            function showBillecta() {
                billectaBlock.show();
                $(billectaBlockTab).addClass("content-link-active");
                // empty bank account & clearing for manual
                $("#ClearingInput").val("");
                $("#BankAccountInput").val("");


                manualBlock.hide();
                $(manualBlockTab).removeClass("content-link-active");

                //Last stage, user should be able to submit form
                if (selectBankAccountBlock.css('display') == "block") {
                    submitFormButton.prop("disabled", false);
                } else {
                    submitFormButton.prop("disabled", true);
                }
            }

            function showSubscriber() {
                existingSubscriptionBlock.show();
                paymentOptionsButton.show();
                submitFormButton.hide();
                inputBlock.hide();
                labelBlock.show();

            }

            function showManual() {
                billectaBlock.hide();
                $(billectaBlockTab).removeClass("content-link-active");

                // empty bank account for billecta
                $("#BankAccountDropDown").val("");

                manualBlock.show();
                $(manualBlockTab).addClass("content-link-active");
                submitFormButton.prop("disabled", false);
            }

            function selectPaymentType() {
                //if pren -> submit, else stageTwo, change payment type to AG
                var radioValue = $("input[name='SelectPayment']:checked").val();
                if (radioValue == "account") {
                    paymentTypeHiddenInput.val(account);
                    $("#PaymentStepForm").submit();
                } else {
                    existingSubscriptionBlock.hide();
                    paymentTypeHiddenInput.val(autoGiro);
                    setStageTwo();

                }
            }

            function socialSecurityButtonClick() {
                if (!validatePersonalNumber(input.val()))
                    return;

                // Should fix that the window doesn't grow dynamically
                $("#containerWithHeight").removeAttr("style");

                label.html(input.val());
                uservalues.SocialSecurityNumber = input.val();

                socialSecurityButton.prop("disabled", true);
                input.prop("disabled", true);
                socialSecurityButtonSpinner.show();

                var data = {
                    timestamp: new Date().getTime(),
                    ssn: input.val()
                };

                $.ajax({
                    url: "/Common/GetSubscriberInfo",
                    type: "POST",
                    contentType: "application/json",
                    dataType: "json",
                    data: JSON.stringify(data),
                    success: function (response) {
                        setTimeout(function () {
                            //spinner.stop();
                            //Set values
                            uservalues.hasAccount = response.HasAccount;
                            uservalues.blCustomer = response.BLCustomer;
                            uservalues.prenCustomer = response.PrenCustomer;
                            uservalues.autogiroCustomer = response.AutogiroCustomer;
                            uservalues.forcedAutogiro = response.ForcedAutoGiro;
                            uservalues.validForBenefits = response.ValidForBenefits;
                            uservalues.message = response.Message;

                            socialSecurityButtonSpinner.hide();
                            setPaymentType();

                        }, 500);
                    },
                    error: function (jqXhr, textStatus, errorThrown) {
                        socialSecurityButtonSpinner.hide();
                        //Utils.HandleServiceFailure(jqXhr, textStatus, errorThrown, $form);
                        //adjustSliderHeight();
                    }
                });
            }

            function setPaymentType() {
                message.text("").addClass("hidden");
                //Enable input, so it will be submitted
                input.prop('disabled', false);
                // customer is not allowed to create subscription
                if (campaignCode.val() !== "" && !uservalues.validForBenefits) {
                    ModalHandler.ConfirmModal("VILL DU TECKNA UTAN PREMIE?", uservalues.message, "TECKNA UTAN PREMIE", function (result) {
                        if (result) {
                            //yes 
                            //Remove campaign code
                            $('#siteModal').modal('hide');
                            campaignCode.val("");
                            setPaymentType();
                            return;
                        } else {
                            //no 
                            //Close modal 
                            $('#siteModal').modal('hide');
                            location.reload();
                        }
                    });
                }
                else if (uservalues.autogiroCustomer) { //Customer has AutoGiro-account, send them to confirmation

                    paymentTypeHiddenInput.val(account);
                    $("#PaymentStepForm").submit();
                } else if (uservalues.blCustomer) {  //Ask them to change to AutoGiro
                    showSubscriber();

                    paymentTypeHiddenInput.val(account);
                } else {
                    paymentTypeHiddenInput.val("");
                    //titleH1.html(titleH1.html() + ": " + autoGiro);

                    setStageTwo();
                }
            }

            (function (a) { (jQuery.browser = jQuery.browser || {}).mobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)) })(navigator.userAgent || navigator.vendor || window.opera);

            function selectBankButtonClick() {
                // Show: SelectBankIdOverlay
                // openBankId()
                // if not mobile -> openbankid

                if (!$.browser.ismobile) {
                    openBankId(false);
                } else {
                    // Show: SelectBankIdOverlay
                    $("#SelectBankIdOverlay").show();
                    $("#openBankIDApp").click(function () {
                        openBankId(true);
                        $("#openBankIDApp")
                    });
                    $("#otherUnitBankID").click(function () {
                        openBankId(false);
                    });
                    $("#CloseSelectBankIdOverlayButton").click(function () {
                        $("#SelectBankIdOverlay").hide();
                    });
                }

                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera 
            }

            function openBankId(mobile) {

                //Reset in case user calls multiple times
                hasOpenedBankid = false;
                selectBankLabel.html($("#SelectBankInput option:selected").text());

                selectBankButton.prop("disabled", true);
                selectBankInput.prop("disabled", true);

                spinner.spin($("#BankIdSpinner").get(0));

                var data = {
                    'bankType': selectBankInput.val(),
                    'socialSecurityNumber': uservalues.SocialSecurityNumber
                };

                $.ajax({
                    url: "/Account/BillectaInitiation",
                    type: "POST",
                    contentType: "application/json",
                    dataType: "json",
                    data: JSON.stringify(data),
                    success: function (response) {
                        setTimeout(function () {
                            console.log(response);
                            setStageThree();
                            if (response.PublicId !== "") {
                                pollInterval = setInterval(function () { getBankAccountsFromBillecta(response.PublicId, mobile); }, 1000);
                            } else {
                                console.log("Unable to start billecta");
                            }


                        }, 500);
                    },
                    error: function () {
                        //alert('error');
                        $("#SelectBankIdOverlay").hide();
                    }
                });
            }


            function getBankAccountsFromBillecta(publicId, mobile) {
                $.ajax({
                    url: "/Account/BillectaPolling",
                    type: "GET",
                    contentType: "application/json",
                    dataType: "json",
                    data: { publicId: publicId },
                    success: function (data) {

                        if (mobile && !hasOpenedBankid) {
                            // If mobile open app directly https://app.bankid.com/?autostarttoken=[TOKEN]&redirect=null
                            hasOpenedBankid = true;
                            bankIdDefaultMessage.hide();
                            bankIdWaitingForResponseFromAppMessage.show();
                            // Change text to "Väntar på svar på BankID"
                            window.location = 'https://app.bankid.com/?autostarttoken=' + data.BankIdAutostartToken + '&redirect=null';
                        } else if (typeof data.QR != "undefined" && data.QR != null) {
                            qrImage.attr("src", data.QR);
                            qrImage.show();
                        }

                        if (data.Status >= 1) {
                            if (pollInterval) {
                                clearInterval(pollInterval);
                            }
                            //Success
                            if (data.Status == 1) {


                                var length = selectBankAccountInput.options.length;
                                for (let i = 0; i < length; i++) {
                                    selectBankAccountInput.options[i] = null;
                                }

                                selectBankAccountInput.append(new Option("Välj ditt bankkonto", "", true));
                                $.each(data.AccountNumbers, function (i, item) {
                                    if (item.Name) {
                                        selectBankAccountInput.append(new Option(item.Name + " (" + item.AccountNo + ")", item.Number));
                                    } else {
                                        selectBankAccountInput.append(new Option(item.Clearing + " - " + item.AccountNo, item.Number));
                                    }
                                });
                                spinner.stop();
                                setStageFour();
                            } else if (data.Status == 2) { //Fail
                                console.log(data);
                                bankIdErrorMessage.show();
                                bankIdDefaultMessage.hide();
                                qrImage.hide();
                                spinner.stop();
                            }
                        }
                    },
                    error: function () {
                        bankIdErrorMessage.show();
                        bankIdDefaultMessage.hide();
                        bankIdWaitingForResponseFromAppMessage.hide();
                        qrImage.hide();
                        spinner.stop();
                    }
                });

            }

            var validatePersonalNumber = function (input) {
                // Check valid length & form
                if (!input) return false;

                if (input.indexOf('-') == -1) {
                    if (input.length === 10) {
                        input = input.slice(0, 6) + "-" + input.slice(6);
                    } else {
                        input = input.slice(0, 8) + "-" + input.slice(8);
                    }
                }
                if (!input.match(/^(\d{2})(\d{2})(\d{2})\-(\d{4})|(\d{4})(\d{2})(\d{2})\-(\d{4})$/)) return false;

                // Clean input
                input = input.replace('-', '');
                if (input.length == 12) {
                    input = input.substring(2);
                }

                // Declare variables
                var d = new Date(((!!RegExp.$1) ? RegExp.$1 : RegExp.$5), (((!!RegExp.$2) ? RegExp.$2 : RegExp.$6) - 1), ((!!RegExp.$3) ? RegExp.$3 : RegExp.$7)),
                    sum = 0,
                    numdigits = input.length,
                    parity = numdigits % 2,
                    i,
                    digit;

                // Check valid date
                if (Object.prototype.toString.call(d) !== "[object Date]" || isNaN(d.getTime())) return false;

                // Check luhn algorithm
                for (i = 0; i < numdigits; i = i + 1) {
                    digit = parseInt(input.charAt(i))
                    if (i % 2 == parity) digit *= 2;
                    if (digit > 9) digit -= 9;
                    sum += digit;
                }
                return (sum % 10) == 0;
            };

            //Enter Social Security number
            function setStageOne() {
                inputBlock.show();

                labelBlock.hide();
                selectBankBlock.hide();
                selectBankLabelBlock.hide();
                selectBankAccountBlock.hide();
                autogiroTabBlock.hide();
                existingSubscriptionBlock.hide();
                bankIdErrorMessage.hide();
                paymentOptionsButton.hide();
                socialSecurityButton.prop("disabled", false);
                input.prop("disabled", false);
                selectBankInput.prop("disabled", false);
                selectBankButton.prop("disabled", false);

                submitFormButton.show();
                bankIdDefaultMessage.show();
                bankIdWaitingForResponseFromAppMessage.hide();
                submitFormButton.prop("disabled", true);
            }

            //Select Bank
            function setStageTwo() {
                inputBlock.hide();
                selectBankAccountBlock.hide();
                selectBankLabelBlock.hide();


                //IF AG redan är valt, dölj radioknapparna
                if (paymentTypeHiddenInput.val() == autoGiro) {
                    radioInvoiceOrAutogiro.hide();
                } else {
                    paymentTypeHiddenInput.val(autoGiro);
                    radioInvoiceOrAutogiro.show();
                }
                labelBlock.show();
                selectBankBlock.show();
                autogiroTabBlock.slideDown();

                paymentOptionsButton.hide();
                submitFormButton.show();
                submitFormButton.prop("disabled", true);
            }

            //Wait for bankID auth
            function setStageThree() {
                inputBlock.hide();
                labelBlock.hide();
                selectBankBlock.hide();
                selectBankLabelBlock.hide();
                $("#SelectBankIdOverlay").hide();
                bankIdOverlay.show();
            }

            //Select Bank account
            function setStageFour() {
                bankIdOverlay.hide();
                qrImage.hide();
                selectBankBlock.hide();
                selectBankButton.prop("disabled", false);
                selectBankInput.prop("disabled", false);

                labelBlock.show();
                selectBankLabelBlock.show();
                selectBankAccountBlock.show();

                submitFormButton.prop("disabled", false);
            }
        }
    }
});
